export const STATE_HEADER = 'State';
export const CITY_HEADER = 'City';
export const AMOUNT = 'Amount';
export const ACTIONS_HEADER = 'Actions';
